import { StatisticsItemCol } from "@common/components/statistics/StatisticsItemCol"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { hasRole } from "@data/utility/ability"
import { plr } from "@data/utility/Utils"
import moment from "moment"
import React, { useContext, useState } from "react"
import { View } from "react-native"
import { TouchableRipple } from "react-native-paper"
import { connect } from "react-redux"
import checked from "../../../../assets/icons/generic/checked.png"
import money from "../../../../assets/icons/generic/money.png"
import rituals from "../../../../assets/icons/generic/rituals.png"
import liveChat from "../../../../assets/icons/menus/live-chat.png"
import { boxedCardBorderStyle } from "../../../reviewer/BoxedCardBorderStyle"
import StripeExpressDashboardButton from "../../../student/account/StripeExpressDashboardButton"

function CoachStats(props) {
    const [periodName, setPeriodName] = useState("Ce mois-ci")
    const [period, setPeriod] = useState("this_month")
    const lives = props.user?.statistics?.lives

    const onPeriodPress = () => {
        if (periodName === "Ce mois-ci") {
            setPeriodName("Le mois dernier")
            setPeriod("last_month")
        } else {
            setPeriodName("Ce mois-ci")
            setPeriod("this_month")
        }
    }
    const dimensions = useContext(DimensionsContext)

    const startDate =
        period === "this_month"
            ? moment().startOf("month").format("DD MMM")
            : moment().add(-1, "month").startOf("month").format("DD MMM")
    const endDate =
        period === "this_month"
            ? moment().add(-25, "minutes").add(-1, "days").format("DD MMM")
            : moment().add(-1, "month").endOf("month").format("DD MMM")

    const pendingTransferLiveUnits =
        lives?.[period]?.pending_transfer_live_units ?? 0
    const pendingTransferAmount = lives?.[period]?.pending_transfer_amount ?? 0
    const transferredLiveUnits = lives?.[period]?.transferred_live_units ?? 0
    const transferredTransferAmount =
        lives?.[period]?.transferred_transfer_amount ?? 0

    return (
        <View>
            {hasRole(props.user, "tutor") && (
                <View
                    style={{
                        marginTop: 30,
                        marginBottom: 30,
                        borderColor: theme.colors.lightMore,
                        borderTopWidth: 1,
                        borderBottomWidth: 1,
                        backgroundColor: theme.colors.white,
                        paddingHorizontal: 20,
                        paddingVertical: 20,
                        width: dimensions?.width,
                        ...boxedCardBorderStyle,
                    }}
                >
                    <View style={{}}>
                        <TextM fontWeight={"Bold"} fontSize={20}>
                            Mon historique
                        </TextM>
                    </View>

                    <TouchableRipple
                        onPress={onPeriodPress}
                        style={{
                            borderWidth: 1,
                            borderColor: theme.colors.lightMore,
                            backgroundColor: theme.colors.white,
                            borderRadius: 10,
                            alignItems: "center",
                            width:
                                dimensions.width > 800
                                    ? dimensions?.width / 2
                                    : dimensions?.width - 20,
                            paddingVertical: 5,
                            marginTop: 20,
                            alignSelf: "center",
                        }}
                    >
                        <TextM color={theme.colors.grey} fontWeight="Medium">
                            {periodName.toUpperCase()}
                        </TextM>
                    </TouchableRipple>
                    <TextM
                        fontWeight={"Light"}
                        fontSize={12}
                        style={{ textAlign: "center" }}
                    >
                        Du {startDate} au {endDate}
                        {lives?.[period]?.pending_review_live_units > 0 && "*"}
                    </TextM>

                    {props.user?.stripe_connect_details_submitted ? (
                        <View
                            style={{
                                flexDirection: "row",
                                marginTop: 10,
                                paddingVertical: 10,
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                justifyContent: "space-between",
                                alignSelf: "center",
                                paddingHorizontal: 10,
                            }}
                        >
                            <StatisticsItemCol
                                source={rituals}
                                count={pendingTransferLiveUnits}
                                title={
                                    plr("heure", pendingTransferLiveUnits) +
                                    " de " +
                                    plr("live", pendingTransferLiveUnits) +
                                    " en attente de validation"
                                }
                                style={{
                                    paddingHorizontal: 15,
                                    width: dimensions?.width / 3 - 4,
                                }}
                            />
                            <StatisticsItemCol
                                source={checked}
                                count={transferredLiveUnits}
                                title={
                                    plr("heure", transferredLiveUnits) +
                                    " de " +
                                    plr("live", transferredLiveUnits) +
                                    plr(" validée", transferredLiveUnits)
                                }
                                style={{
                                    paddingHorizontal: 15,
                                    width: dimensions?.width / 3 - 4,
                                }}
                            />
                            <StatisticsItemCol
                                source={rituals}
                                count={pendingTransferAmount + "€"}
                                title={"montant en attente de validation"}
                                style={{
                                    paddingHorizontal: 15,
                                    width: dimensions?.width / 3 - 4,
                                }}
                            />
                            <StatisticsItemCol
                                source={money}
                                count={transferredTransferAmount + "€"}
                                title={"montant validé"}
                                style={{
                                    paddingHorizontal: 15,
                                    width: dimensions?.width / 3 - 4,
                                }}
                            />
                        </View>
                    ) : (
                        <View
                            style={{
                                flexDirection: "row",
                                marginTop: 10,
                                paddingVertical: 10,
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                justifyContent: "space-between",
                                alignSelf: "center",
                                paddingHorizontal: 10,
                            }}
                        >
                            <StatisticsItemCol
                                source={liveChat}
                                count={lives?.[period]?.validated_live_units}
                                title={
                                    plr(
                                        "heure",
                                        lives?.[period]?.validated_live_units
                                    ) +
                                    " de " +
                                    plr(
                                        "live",
                                        lives?.[period]
                                            ?.pending_review_live_units
                                    ) +
                                    plr(
                                        " validée",
                                        lives?.[period]?.validated_live_units
                                    )
                                }
                                style={{
                                    paddingHorizontal: 15,
                                    width: dimensions?.width / 3 - 4,
                                }}
                            />
                            <StatisticsItemCol
                                source={money}
                                count={
                                    lives?.[period]?.validated_transfer_amount +
                                    "€"
                                }
                                title={"montant validé cumulé"}
                                style={{
                                    paddingHorizontal: 15,
                                    width: dimensions?.width / 3 - 4,
                                }}
                            />
                        </View>
                    )}

                    <View
                        style={{
                            marginTop: 40,
                            paddingVertical: 10,
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "center",
                            alignSelf: "center",
                            paddingHorizontal: 10,
                        }}
                    >
                        {lives?.[period]?.pending_review_live_units > 0 &&
                            !props.user?.stripe_connect_details_submitted && (
                                <TextM
                                    fontWeight={"Light"}
                                    style={{ marginTop: 10 }}
                                    fontSize={10}
                                    wrap
                                >
                                    *Les statistiques ne prennent pas en compte
                                    certains Lives en attente de validation
                                </TextM>
                            )}
                    </View>

                    <StripeExpressDashboardButton
                        style={{ textAlign: "center" }}
                    />
                </View>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        students: state.data.currentUser?.object?.students,
        getStudentRequest: state.api.getStudents?.request,
        interviewFinalizeSuccess: state.api.interviewFinalize?.success,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(CoachStats)
